import gql from 'graphql-tag';

const updateVideoAtomicQuery = gql`
  mutation UpdateVideoAtomic($input: VideoDeltaInput!, $videoId: String!) {
    updateVideoAtomic(input: $input, videoId: $videoId)
  }
`;

const updateVideoAtomic = {
  mutation: updateVideoAtomicQuery,
  module: 'video',
  buildVariables: ({ input, videoId }: { input: any; videoId: string }) => ({
    input,
    videoId
  })
} as const;

export default updateVideoAtomic;
